module.exports = __webpack_public_path__ + "static/media/netflixCloneScreenshot.5086ea0c.png";